import { Core } from "@faire/design-tokens";
import { Span } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { PropsWithChildren } from "react";

export const LabelOptional: React.FC<
  PropsWithChildren<{ optional?: boolean; optionalLabel?: string }>
> = ({ children, optional, optionalLabel }) => {
  return optional ? (
    <>
      {children}&nbsp;
      <Span color={Core.text.subdued}>
        {optionalLabel ?? (
          <StrictLocalMsg
            defaultMessage="(optional)"
            description={{ text: "as in not required" }}
          />
        )}
      </Span>
    </>
  ) : (
    children
  );
};
